import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Spin, Select } from 'antd';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, PieChart, Pie, Cell } from 'recharts';
import axios from 'axios';
import Header from './header';
import Sidebar from './sidebar';

const { Option } = Select;

const FamilyCharts = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState('दिर्गकालिन रोग');

  const fetchData = async (endpoint) => {
    try {
      const response = await axios.get(endpoint);
      const formattedData = response.data.map(item => ({
        type: item[0],
        value: item[1],
      }));
      setData(formattedData);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    let endpoint;
    switch (selectedOption) {
      case 'दिर्गकालिन रोग':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-long-term-diseases';
        break;
      case 'आम्दानीको श्रोत':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-income-source';
        break;
      case 'अपांगताको प्रकार':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-disability';
        break;
      case 'खाना पकाउने इन्धन':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-cooking-source';
        break;
      case 'मातृभाषा':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-mother-tongue';
        break;
      case 'जात':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-caste';
        break;
      case 'धर्म':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-religion';
        break;
      case 'फोहरको व्यवस्थापन':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-waste-management';
        break;
      case 'घरको प्रकार':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-house-category';
        break;
      case 'कृषि':
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-agriculture-type';
        break;
      case 'परिवारमुलीको लिङ्ग':
        endpoint='https://ward3-chandrapur-api.palikaapp.com/api/family/count-owner-sex';
        break;
      case 'शैक्षिक सँस्था':
        endpoint='https://ward3-chandrapur-api.palikaapp.com/api/family/count-education-level';
        break;
      case 'शैक्षिक सुविधा':
        endpoint='https://ward3-chandrapur-api.palikaapp.com/api/family/count-education-privilege';
        break;

      case 'स्वास्थ्य सुविधा':
        endpoint='https://ward3-chandrapur-api.palikaapp.com/api/family/count-health-privilege'
        break;
      default:
        endpoint = 'https://ward3-chandrapur-api.palikaapp.com/api/family/count-long-term-diseases';
    }

    fetchData(endpoint);
  }, [selectedOption]);

  const COLORS = ['#1890ff', '#f5222d', '#52c41a', '#faad14', '#13c2c2'];

  const handleChange = (value) => {
    setSelectedOption(value);
    setLoading(true);
  };

  return  (
    <div className="flex flex-row">
      {/* Sidebar */}
      <Header/>
  
      {/* Main Content */}
      <div className="flex-1 p-4 pt-20">
        <Sidebar/>
       <div className='px-20 ml-40'> 
       <h1 className="text-2xl font-bold mb-6 pt-5 ml-20">परिवारको मानचित्र</h1>
        {/* Dropdown for Selection */}
        <div className="flex justify-start mb-2 p-5 ml-5 px-10">
          <Select
            defaultValue="दिर्गकालिन रोग"
            style={{ width: 200 }}
            onChange={handleChange}
            className="border rounded-md"
          >
            <Option value="दिर्गकालिन रोग">दिर्गकालिन रोग</Option>
            <Option value="आम्दानीको श्रोत">आम्दानीको स्रोत</Option>
            <Option value="अपांगताको प्रकार">अपांगताको प्रकार</Option>
            <Option value="खाना पकाउने इन्धन">खाना पकाउने इन्धन</Option>
            <Option value="मातृभाषा">मातृभाषा</Option>
            <Option value="जात">जात</Option>
            <Option value="धर्म">धर्म</Option>
            <Option value="फोहरको व्यवस्थापन">फोहरको व्यवस्थापन</Option>
            <Option value="घरको प्रकार">घरको प्रकार</Option>
            <Option value="कृषि">कृषि</Option>
            <Option value="परिवारमुलीको लिङ्ग">परिवारमुलीको लिङ्ग</Option>
            <Option value="शैक्षिक सँस्था">शैक्षिक सँस्था</Option>
            <Option value="शैक्षिक सुविधा">शैक्षिक सुविधा</Option>
            <Option value="स्वास्थ्य सुविधा">स्वास्थ्य सुविधा</Option>
          </Select>
        </div>
  
        {/* Charts Section */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 p-5">
          {/* Bar Chart */}
          <div className="p-4 bg-white rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-center mb-4">
              {selectedOption} - Bar Chart
            </h2>
            {loading ? (
              <div className="flex justify-center items-center h-64">
                <Spin size="large" />
              </div>
            ) : (
              <BarChart
                width={500}
                height={300}
                data={data}
                margin={{ top: 20, right: 30, bottom: 5, left: 0 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="type" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="value" fill="#1890ff" />
              </BarChart>
            )}
          </div>
  
          {/* Pie Chart */}
          <div className="p-4 bg-white rounded-lg shadow-md">
            <h2 className="text-xl font-semibold text-center mb-4">
              {selectedOption} - Pie Chart
            </h2>
            {loading ? (
              <div className="flex justify-center items-center h-64">
                <Spin size="large" />
              </div>
            ) : (
              <PieChart width={500} height={300}>
                <Pie
                  data={data}
                  dataKey="value"
                  nameKey="type"
                  outerRadius={120}
                  fill="#8884d8"
                  label={({ index }) => `${data[index].type}`}
                >
                  {data.map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip />
              </PieChart>
            )}
          </div>
        </div>
      </div>
    </div>
    </div>
  );
    
}
export default FamilyCharts;
